// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__32cSV","author":"Table_author___b6yo","authorImage":"Table_authorImage__1ze5l","unreadRow":"Table_unreadRow__3gNRe"};